<lib-setting-cover
  [forceSquare]="forceSquare"
  (reset)="reset()"
  (saved)="saved($event)"
  [contextId]="contextId"
  [context]="context"
  [coverType]="coverType"
  [point]="model.value"
></lib-setting-cover>
